import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const UPDATE_DRAW_MAP_TASK_COMMENT = gql`
  mutation UpdateMapDrawTaskComment($input: UpdateMapDrawTaskCommentInput!) {
    updateMapDrawTaskComment(input: $input) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
